// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"300":"ffbf879a","409":"ae0e64b9"}[chunkId] + ".chunk.css";
};